var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("btn btn-" + _vm.type + " btn-flat"),attrs:{"title":_vm.title},on:{"click":function($event){return _vm.sendRequest(_vm.route)}}},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }